import Load from 'components/Load';
import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';

const AsyncAuthContainer = Load(
  () =>
    import(
      /* webpackChunkName: "auth-container" */ './containers/AuthContainer'
    ),
);
const AsyncCheckoutChildRoutes = Load(
  () => import(/* webpackChunkName: "checkout" */ './CheckoutChildRoutes'),
);

const CheckoutRoutes = [
  <Route
    key="checkout-auth"
    path={`${basePath}/booking/auth`}
    component={AsyncAuthContainer}
  />,
  <Route
    key="checkout"
    path={`${basePath}/booking/:tripId`}
    component={AsyncCheckoutChildRoutes}
  />,
];

export default CheckoutRoutes;
